import React, { useState } from 'react'
import TWControls from 'components/controls/TWControls'
import { Form } from 'components/controls/useForm'
const centerOptions = [
	{ selectId: '1', selectValue: 'Center 1' },
	{ selectId: '2', selectValue: 'Center 2' },
	{ selectId: '3', selectValue: 'Center 3' },
	{ selectId: '4', selectValue: 'Center 4' },
]

const BulkTenantsAddPopup = ({ myCenters, handlePostFleetLocations }) => {
	const [selectedCenter, setSelectedCenter] = useState('')

	const submitHandler = e => {
		handlePostFleetLocations(selectedCenter)
	}

	const handleInputChange = e => {
		console.log(`e.target.value: `, e.target.value)

		setSelectedCenter(e.target.value)
	}

	return (
		<Form sx={{ m: 1, minWidth: 420 }} onSubmit={submitHandler}>
			<div className="grid grid-cols-12 gap-4">
				<div className="col-span-12 newLocation__imageHolder">
					<h3 xs={12}>{`location.assetName: location.city, location.stateProvince`}</h3>
					{/* <h3 xs={12}>{`${location.assetName}: ${location.city}, ${location.stateProvince}`}</h3> */}
				</div>
				<div className="col-span-12">
					<p>
						{`Archived locations are removed from the active location list but can be recoverd. All of location.assetName associated notes, partners, tasks, files and images are preserved and will be
						restored when the archived location is recovered.`}{' '}
					</p>
					{/* <p>
						{`Archived locations are removed from the active location list but can be recoverd. All of ${location.assetName} associated notes, partners, tasks, files and images are preserved and will be
						restored when the archived location is recovered.`}{' '}
					</p> */}
				</div>
				<div className="col-span-12">
					<div className="newLocation__imageHolder">
						<TWControls.SelectId
							name="selectedCenter"
							label="Retail Center"
							value={selectedCenter}
							onChange={handleInputChange}
							options={myCenters}
						/>
					</div>
				</div>
				<div className="col-span-12">
					<div className="newLocation__imageHolder">
						<TWControls.Button size="small" type="submit" text="Post" />
					</div>
				</div>
			</div>
		</Form>
	)
}

export default BulkTenantsAddPopup
